export default __webpack_public_path__ + "static/media/placeholder.7b57ae03.png";